import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var Brand =
/** @class */
function (_super) {
  __extends(Brand, _super);

  function Brand() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Brand = __decorate([Component({
    name: 'Brand'
  })], Brand);
  return Brand;
}(Vue);

export default Brand;